import React from "react";
import axios from "axios";
import { Dropdown, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { GlobalOutlined } from "@ant-design/icons";
import { Error, Success } from "../Messages/Messages";
import { generalErrorAlert } from "../GeneralErrorAlert";
import { LANGUAGE_OPTIONS, getLanguageOption } from "./languageOptions";

const { Text } = Typography;

function ChangeLanguageDropdown() {
  const { t, i18n } = useTranslation("dashboard");

  const updateLanguageInDb = async language => {
    try {
      await axios
        .put(
          `${process.env.REACT_APP_BACKEND_URL}/users/update-language`,
          {
            language
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            Success(res.data.successMessage);
          } else {
            Error(res.data.errorMessage);
          }
        })
        .catch(err => {
          generalErrorAlert(err);
        });
    } catch (error) {
      generalErrorAlert(error);
    }
  };

  const handleMenuClick = ({ key }) => {
    i18n.changeLanguage(key);
    updateLanguageInDb(key);
  };

  const current = getLanguageOption(i18n.language);
  const isActive = lang => current.code === lang;

  const items = LANGUAGE_OPTIONS.map(lang => ({
    key: lang.code,
    label: (
      <Space>
        <img className="language-country-flag" alt={lang.short} src={lang.flag} />
        <Text strong={isActive(lang.code)}>{lang.name}</Text>
        {isActive(lang.code) && (
          <Text type="success" style={{ marginInlineStart: "8px", fontSize: "12px" }}>
            ✓ {lang.activeLabel}
          </Text>
        )}
      </Space>
    )
  }));

  return (
    <div className="language-dropdown-container">
      <Dropdown
        menu={{
          items,
          onClick: handleMenuClick,
          selectedKeys: [current.code]
        }}
        placement="bottomRight"
        arrow={{ pointAtCenter: true }}
        trigger={["click"]}
      >
        <div
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            padding: "6px 12px",
            borderRadius: "8px",
            border: "1px solid #d9d9d9",
            boxShadow: "0 2px 0 rgba(0,0,0,0.02)",
            transition: "all 0.3s",
            backgroundColor: "#fff",
            height: 43
          }}
          className="language-selector"
        >
          <GlobalOutlined style={{ fontSize: "16px", color: "#1890ff" }} />
          <Text style={{ margin: "0 4px" }}>{current.short}</Text>
          <img className="language-country-flag" alt={current.short} src={current.flag} />
        </div>
      </Dropdown>
    </div>
  );
}

export default ChangeLanguageDropdown;
